import * as Yup from 'yup';
import { IInitialValues, IValidationRules } from '../views/challenge/Challenge';
import { IChallengeItem } from './fetch-service';

export const getValidationSchema = (validation: IValidationRules) => {
  // FIXME replace any to proper types
  const schema: any = {};
  Object.keys(validation).forEach(key => {
    // TODO figure out where 'null' came from
    if (!key || key === 'null' || !validation[key] || validation[key].length === 0) return;
    const field = validation[key];

    schema[key] = field.reduce(
      (yup: any, item: any) => {
        if (item.params) {
          if (item.params?.[1]?.includes('Card number') && typeof yup.test === 'function' && item.params?.[0]) {
            yup = yup.test('card-test', item.params?.[1], function (value: string) {
              if (!value) return false;
              return new RegExp(item.params?.[0]).test(value.trim().replace(/\s/g, ''));
            });
          } else {
            yup = yup[item.value](...item.params);
          }
        } else {
          yup = yup[item.value]();
        }

        return yup;
      },
      { ...Yup },
    );
  });

  return Yup.object().shape({ ...schema });
};

export const getInitialValues = (
  schema: IInitialValues,
  template?: IChallengeItem[] | null,
  isCard?: boolean,
): IInitialValues => {
  if (!template) return schema;

  let newSchema = { ...schema };
  const rules: IValidationRules = {};
  const newValues: { [key: string]: string } = { ...schema.values };

  template?.forEach(el => {
    const key = isCard && el.attributes?.name ? el.attributes?.name : (el.dataId as string);
    if (key && Array.isArray(el.validations)) {
      rules[key] = [];

      const isNumber = el.validations.some(v => v.type === 'min' || v.type === 'max');
      el.validations.forEach((item, index) => {
        if (index === 0 && isNumber) {
          rules[key].push({ value: 'number', params: null });
        } else if (index === 0) {
          rules[key].push({ value: 'string', params: null });
        }
        switch (item.type) {
          case 'required':
            rules[key].push({ value: 'required', params: [item.errorMessage] });
            break;
          case 'min':
          case 'max':
            rules[key].push({ value: 'min', params: [item.value, item.errorMessage] });
            break;
          case 'minLength':
            rules[key].push({
              value: 'test',
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              params: ['minLength', item.errorMessage, val => val.length >= item.value],
            });
            break;
          case 'maxLength':
            rules[key].push({
              value: 'test',
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              params: ['maxLength', item.errorMessage, val => val.length <= item.value],
            });
            break;
          case 'regExStripWhitespace':
          case 'regEx':
            rules[key].push({ value: 'matches', params: [item.value, item.errorMessage] });
            break;
          // case 'regExStripWhitespace':
          //   rules[el.dataId as string].push({
          //     value: 'test',
          //     params: [
          //       el.dataId as string,
          //       val => {
          //         console.log('val=====', val, val?.replace(/\s/g, ''));
          //         return new RegExp(item?.value).test(val?.replace(/\s/g, ''));
          //       },
          //     ],
          //   });
          //   break;
          case 'checked':
            rules[key].push({ value: 'test', params: ['checked', item.errorMessage, val => !!val] });
            break;
        }
      });
    }

    if ((key && el.component === 'Input') || el.component === 'SmallInput') {
      newValues[key] = '';
    }

    if (el.children) {
      newSchema = getInitialValues(newSchema, el.children, isCard);
    }
  });
  return {
    values: { ...newSchema.values, ...newValues },
    validation: { ...newSchema.validation, ...rules },
  };
};

export const findItem = (field: string, template: IChallengeItem[]): IChallengeItem | null | undefined => {
  let temp;
  template.forEach(el => {
    if (el.children) {
      const item = findItem(field, el.children);
      if (item) {
        temp = item;
      }
    }
    if (el?.attributes?.name === field) {
      temp = el;
    }
  });

  return temp;
};
